import { BtnPreWarning, BtnSecondary } from '@components/buttons';
import { showDialog } from '@components/dialog';
import { IcoRefresh, IcoTrash } from '@components/icons';

/**
 * The toggle button for prices / coupons.
 */
export function ArchiveToggle({
  isEnabled,
  itemName,
  onToggle,
}: {
  isEnabled: boolean;
  onToggle(): void;
  /**
   * "price point" or "coupon"
   */
  itemName: string;
}) {
  const toggleArchived = async () => {
    const accepted = await showDialog(
      !isEnabled
        ? {
            title: `Activate ${itemName}?`,
            children: `This will enable signups with this ${itemName}.`,
            confirmButtonText: 'Activate',
            mode: 'ok',
          }
        : {
            mode: 'warn',
            title: `Archive ${itemName}?`,
            children: `Signups will no longer be allowed with this ${itemName}.`,
            confirmButtonText: 'Archive',
          },
    );
    if (accepted) {
      onToggle();
    }
  };

  if (!isEnabled) {
    return (
      <BtnSecondary class="md:ml-auto" type="button" onClick={toggleArchived}>
        <IcoRefresh />
        <span class="ml-1">Activate</span>
      </BtnSecondary>
    );
  }

  return (
    <BtnPreWarning class="md:ml-auto" type="button" onClick={toggleArchived}>
      <IcoTrash />
      <span class="ml-1">Archive</span>
    </BtnPreWarning>
  );
}
